<template>
    <div class="text-center">
        <div class="spinner-loading"><div></div><div></div><div></div></div>
    </div>
</template>

<script>
export default {
    name: "loading"
}
</script>

<style scoped>
.spinner-loading {
    display: inline-block;
    position: relative;
    width: 80px;
    height: 80px;
}
.spinner-loading div {
    display: inline-block;
    position: absolute;
    left: 8px;
    width: 16px;
    background: var(--bs-primary);
    animation: spinner-loading  0.8s cubic-bezier(0, 0.5, 0.5, 1) infinite;
}
.spinner-loading div:nth-child(1) {
    left: 8px;
    animation-delay: -0.24s;
}
.spinner-loading div:nth-child(2) {
    left: 32px;
    animation-delay: -0.12s;
}
.spinner-loading div:nth-child(3) {
    left: 56px;
    animation-delay: 0;
}
@keyframes spinner-loading {
    0% {
        top: 8px;
        height: 64px;
    }
    50%, 100% {
        top: 24px;
        height: 32px;
    }
}

</style>
